import Copy from '@nib-components/copy';
import styled from 'styled-components';
import {linkLoud} from '@nib-components/theme';

export const CopyWithColoredLink = styled(Copy)`
  & > a {
    color: ${linkLoud};
  }
`;
